import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withTheme, withStyles } from "@material-ui/core/styles";
import { withModulesManager, withHistory } from "@openimis/fe-core";
import PolicyHolderEnrollmentSearcher from "../../components/PolicyHolderEnrollmentSearcher";

const styles = (theme) => ({
  page: theme.page,
});

class PolicyHolderEnrollmentHomePage extends Component {
  onDoubleClick = (enrollment) => {
    if (this.props.history && enrollment?.uuid) {
      this.props.history.push(
        `/enrollment/policyholder/${enrollment.uuid}/detail`
      );
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.page}>
        <PolicyHolderEnrollmentSearcher
          cacheFiltersKey="enrollmentPolicyHolderPageFiltersCache"
          onDoubleClick={this.onDoubleClick}
        />
      </div>
    );
  }
}

export default injectIntl(
  withModulesManager(
    withHistory(
      withTheme(withStyles(styles)(PolicyHolderEnrollmentHomePage))
    )
  )
);
